module.exports = __webpack_public_path__ + "static/media/role2.e2757292.webp";